import styled from "styled-components";

const BankSwap = styled.div`
  & {
    display:flex;
  }
  .selectDropDownMenu {
    min-width: 105px;
  }
  tr:nth-of-type(odd) {
    background-color: #f9f9f9;
  }
  .bankSwapTable {
    width: 95%;
    max-width: 95%;
    margin-top: 20px;
  }
  td {
    min-width: 100px;
  }
  .main {
    padding: 20px;
  }
  .results {
    padding: 50px;
    text-align: center;
    background-color: #2196f3;
  }
  .actions {
    text-align: center;
    height: 100px;
  }
  .helper-text {
    width: 0;
  }
  .helper-text-success {
    color: #4f8a10;
    background-color: #dff2bf;
    padding: 12px;
    width: auto;
  }
  .helper-text-error {
    color: #d8000c;
    background-color: #ffbaba;
    padding: 12px;
    width: auto;
  }
  nav {
    height: 89vh;
  }
  .selectMenu {
    min-width: 200px;
    margin-left: 20px;
  }
  .calcTitle {
    margin-left: 10px;
  }
  .forwardCurveTable {
    width: 90%;
    margin-top: 20px;
    overflow: auto;
  }
  .downloadBtn {
    margin-left: 20px;
  }
`;

export default BankSwap;
